
class ListOfImagesDialogResult {
    constructor() {

        /** @type {Object}  */
        this.selectedItem = null;

    }
}

export { ListOfImagesDialogResult }
